<template lang="pug">
	.container-fluid
		.card
			.card-header.bg-info.text-white
				span.fa.fa-search.mr-2
				| Consultas
			.card-body
				.row
					.col-xs-12.col-sm-12.col-md-12.col-lg-4.col-xl-4
						.form-group
							label(for='') Emisoras
							input-query(
								url='gestion-egm/php/api/query-emisoras.php'
								:realtime='true'
								placeholder='Añade emisoras'
								input-class='form-control'
								@selected="ponEmisora($event)"
							)
							.alert.alert-info.mt-2(v-if="filtro.emisoras.length === 0")
								span.fa.fa-info-circle.mr-2
								| Si no añades ninguna emisora se consultarán todas las que contengan datos
						table.table.table-striped.mt-2.mb-2(v-if="filtro.emisoras.length > 0")
							tbody
								tr(v-for="emisora in filtro.emisoras", :key="emisora.ID_emisora")
									td.text-left {{emisora.nombre}}
									td.text-right
										button.btn.btn-danger(@click="quitaEmisora(emisora)")
											span.fa.fa-trash
					.col-xs-12.col-sm-12.col-md-6.col-lg-4.col-xl-4
						.form-group
							label(for='' v-if="filtro.tipo === 'general'") Fecha de inicio
							label(v-else='') Fecha
							datepicker(
								:monday-first='true'
								:language='$dateLang'
								:bootstrap-styling='true'
								minimum-view='month'
								:typeable="false"
								format='MMMM, yyyy'
								v-model='filtro.fechaIni'
								:disabled-dates="ignoraFechas"
							)
						hr(v-if="filtro.tipo === 'general'")
						.form-group(v-if="filtro.tipo === 'general'")
							label(for='') Fecha de fin
							datepicker(
								:monday-first='true'
								:language='$dateLang'
								:bootstrap-styling='true'
								minimum-view='month'
								:typeable="false"
								format='MMMM, yyyy'
								v-model='filtro.fechaFin'
								:disabled-dates="ignoraFechas"
							)
					.col-xs-12.col-sm-12.col-md-6.col-lg-4.col-xl-4
						.form-group
							label(for='') Tipo de informe
							br
							.btn-group
								button.btn(:class="(filtro.tipo === 'general') ? 'btn-primary' : 'btn-default'" @click="filtro.tipo = 'general'")
									| General
								button.btn(:class="(filtro.tipo === 'horario') ? 'btn-primary' : 'btn-default'" @click="filtro.tipo = 'horario'")
									| Horario
							hr
							label(for='') Inclu&iacute;r
							br
							.btn-group
								button.btn(:class="(filtro.incluirTablas) ? 'btn-primary' : 'btn-default'" @click='filtro.incluirTablas = !filtro.incluirTablas')
									| Tablas
								button.btn(:class="(filtro.incluirGraficas) ? 'btn-primary' : 'btn-default'" @click='filtro.incluirGraficas = !filtro.incluirGraficas')
									| Gráficas
			.card-footer
				.row
					.col.text-left
						button.btn.btn-sm.btn-primary(@click='consultar')
							span.fa.fa-search.mr-2
							| Consultar
					.col.text-right
						button.btn.btn-sm.btn-warning(@click='gestionEdiciones = true')
							span.fa.fa-edit.mr-2
							| Gestionar ediciones
		.card.mt-3
			.card-header.bg-light
				span.fa.fa-pie-chart.mr-2
				| Resultados
			.card-body(v-if="resultados.porHoras")
				.row
					.col-xs-12.col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-3(v-if="filtro.incluirGraficas")
						chartjs-line(
							v-if="resultados.porHoras"
							:beginatzero="true"
							label="Audiencia por horas"
							:labels="resultados.porHoras.labels"
							:datasets="resultados.porHoras.datasets"
						)
					.col-xs-12.col-sm-12.col-md-12.col-lg-12.col-xl-12(v-if="filtro.incluirTablas")
						.table-responsive
							table.table.table-striped
								thead
									tr
										th Hora
										th(v-for="emisora in resultados.porHoras.datasets") {{emisora.label}}
								tbody
									tr(v-for="(hora, i) in resultados.porHoras.labels")
										td {{hora}}
										td(v-for="emi in resultados.porHoras.datasets") {{emi.data[i]}}
			
			.card-body(v-if="resultados.general")
				.row
					.col-xs-12.col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-3(v-if="filtro.incluirGraficas")
						chartjs-line(
							v-if="resultados.general && resultados.general.labels.length > 1"
							:beginatzero="true"
							label="Audiencia por horas"
							:labels="resultados.general.labels"
							:datasets="resultados.general.datasets"
						)
						.row(v-if="resultados.general && resultados.general.labels.length === 1")
							.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
								chartjs-bar(
									:beginatzero="true"
									label="Audiencia por horas"
									:labels="resultados.general.labels"
									:datasets="resultados.general.datasets"
								)
							.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
								chartjs-pie(
									:beginatzero="true"
									label="EGM"
									:height="200"
									:labels="datosQuesito.labels"
									:datasets="[{data: datosQuesito.data, backgroundColor: datosQuesito.options.backgroundColor}]"
									:backgroundcolor="datosQuesito.options.backgroundColor"
									datalabel="EGM"
									:option="datosQuesito.options"
								)
					.col-xs-12.col-sm-12.col-md-12.col-lg-12.col-xl-12(v-if="filtro.incluirTablas")
						.table-responsive
							table.table.table-striped
								thead
									tr
										th Hora
										th(v-for="emisora in resultados.general.datasets") {{emisora.label}}
								tbody
									tr(v-for="(hora, i) in resultados.general.labels")
										td {{hora}}
										td(v-for="emi in resultados.general.datasets") {{emi.data[i]}}
		gestion-ediciones(v-if='gestionEdiciones' @cerrar='gestionEdiciones = false')
</template>

<script>
import GestionEdiciones from './components/gestion-ediciones'
import axios from 'axios'

export default {
	components: {
		'gestion-ediciones': GestionEdiciones
	},
	data () {
		return {
			filtro: {
				emisoras: [],
				fechaIni: null,
				fechaFin: null,
				tipo: 'general',
				incluirTablas: true,
				incluirGraficas: true
			},
			resultados: {
				porHoras: null,
				general: null
			},
			gestionEdiciones: false,
			ignoraFechas: {
				customPredictor: date => {
					if (!date.getMonth().toString().match(/^(3|6|11)$/)) {
						return true
					}

					return false
				}
			},
			opcionesPie: {
				ticks: {
					min: 0
				}
			}
		}
	},

	computed: {
		datosQuesito () {
			if (!this.resultados.general) {
				return null
			}

			if (this.resultados.general.labels.length > 1) {
				return null
			}

			const datasets = this.resultados.general.datasets

			const obj = {
				labels: [],
				data: [],
				options: {
					ticks: {
						min: 0
					},
					backgroundColor: []
				}
			}

			for (let i = 0; i < datasets.length; i++) {
				obj.labels.push(datasets[i].label)
				obj.data.push(datasets[i].data[0])
				obj.options.backgroundColor.push(datasets[i].backgroundColor)
			}

			return obj
		}
	},

	methods: {
		ponEmisora (ev) {
			for (let i = 0; i < this.filtro.emisoras.length; i++) {
				if (this.filtro.emisoras[i].ID_emisora === ev.datos.ID_emisora) {
					return
				}
			}

			this.filtro.emisoras.push(ev.datos)
		},

		quitaEmisora (datos) {
			for (let i = 0; i < this.filtro.emisoras.length; i++) {
				if (this.filtro.emisoras[i].ID_emisora === datos.ID_emisora) {
					this.filtro.emisoras.splice(i, 1)
					return
				}
			}
		},

		consultar () {
			this.resultados.porHoras = null
			this.resultados.general = null

			this.filtro.fechaIni.setDate(1)
			this.filtro.fechaIni.setHours(0)
			this.filtro.fechaIni.setMinutes(0)
			this.filtro.fechaIni.setSeconds(0)
			this.filtro.fechaIni.setMilliseconds(0)

			if (this.filtro.fechaFin) {
				this.filtro.fechaFin.setDate(1)
				this.filtro.fechaFin.setHours(0)
				this.filtro.fechaFin.setMinutes(0)
				this.filtro.fechaFin.setSeconds(0)
				this.filtro.fechaFin.setMilliseconds(0)
			} else {
				this.filtro.fechaFin = new Date(this.filtro.fechaIni.getTime())
			}

			const form = JSON.parse(JSON.stringify(this.filtro))
			form.fechaIni = (this.filtro.fechaIni) ? Math.floor(this.filtro.fechaIni.getTime() / 1000) : null
			form.fechaFin = (this.filtro.fechaFin) ? Math.floor(this.filtro.fechaFin.getTime() / 1000) : null
			axios.post('/gestion-egm/php/api/consulta.php', form)
				.then(res => {
					if (res.data.resultados.porHoras) {
						this.resultados.porHoras = res.data.resultados.porHoras
						this.resultados.general = null
					} else if (res.data.resultados.general) {
						this.resultados.porHoras = null
						this.resultados.general = res.data.resultados.general
					} else {
						this.resultados.porHoras = null
						this.resultados.general = null
					}
				})
				.catch(this.$responseError)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-egm/vue/app.vue